import { call, put, takeLatest } from 'redux-saga/effects';
import Profile from '../../api/profile';
import { getUserSuccess } from '../actions/auth';
import { actionTypes } from '../actions/profile';

function* updateProfile(action) {
  try {
    const result = yield call(() => Profile.updateProfile(action.payload));
    yield put(getUserSuccess(result));
    action.callback(result);
  } catch (error) {
    console.log(error);
    action.callback(false, error?.response?.data?.message);
  }
}

export default function* profileSaga() {
  yield takeLatest(actionTypes.UPDATE_PROFILE, updateProfile);
}
